<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">Prediction is very difficult, especially if it’s about the future.<br/><em class="italic">—</em>N<span class="smallcaps">IELS </span>B<span class="smallcaps">OHR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ferocity_00000.vue?de90f36e